import { colorSchemeDark, themeQuartz } from "ag-grid-community";

export const investmentMemoGridTheme = themeQuartz
    .withPart(colorSchemeDark)
    .withParams({
        accentColor: "#6B7280",
        backgroundColor: "#1E293B",
        borderColor: "#334155",
        browserColorScheme: "dark",
        chromeBackgroundColor: {
            ref: "foregroundColor",
            mix: 0.07,
            onto: "backgroundColor",
        },
        fontFamily: {
            googleFont: "Inter",
        },
        foregroundColor: "#FFFFFF",
        headerFontSize: 14,
        headerVerticalPaddingScale: 1,
        rowHoverColor: "#1E293B",
        rowBorder: {
            color: "#0f172a",
        },
        rangeSelectionBorderStyle: "none",
        pinnedColumnBorder: "none",
        headerHeight: 42,
    });
